import React, { useContext, useEffect, useState } from "react"

import { useSnackbar } from "../../../../utils/notificacoes"
import RegistradorContext from "../../../../contexts/registradorContext"

import AppBar from "@material-ui/core/AppBar"
import Button from "@material-ui/core/Button"
import CardActionArea from "@material-ui/core/CardActionArea"
import Container from "@material-ui/core/Container"
import Dialog from "@material-ui/core/Dialog"
import IconButton from "@material-ui/core/IconButton"
import Slide from "@material-ui/core/Slide"
import { makeStyles } from "@material-ui/core/styles"
import Toolbar from "@material-ui/core/Toolbar"
import Typography from "@material-ui/core/Typography"
import AirlineSeatReclineNormalIcon from "@material-ui/icons/AirlineSeatReclineNormal"
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos"
import CloseIcon from "@material-ui/icons/Close"
import DeleteIcon from "@material-ui/icons/Delete"
import EditIcon from "@material-ui/icons/Edit"
import LocationOnIcon from "@material-ui/icons/LocationOn"
import MapIcon from "@material-ui/icons/Map"
import Tooltip from "@material-ui/core/Tooltip"
import TransferWithinAStationIcon from "@material-ui/icons/TransferWithinAStation"
import AlertFixo from "@material-ui/lab/Alert"
import Skeleton from "@material-ui/lab/Skeleton"
import { Card, Col, Row } from "react-bootstrap"

import {
    AcessoPorEnderecoEstabelecimentosid,
    ExcluirEndereco,
    RegistrarLogErro,
} from "../../../../services/clientefiel"

import {
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    MenuItem,
    MenuList,
    Paper,
    TextField,
} from "@material-ui/core"

import { Add } from "@material-ui/icons"
import { GoogleMap, Marker } from "@react-google-maps/api"
import usePlacesAutocomplete, { getGeocode } from "use-places-autocomplete"
import { AtualizarEnderecoCliente } from "../../../../services/cliente"
import useAppStore from "../../../../stores/AppStore"
import { ObterPedido } from "../FinalizacaoPedido"

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const useStyles = makeStyles(theme => ({
    fixed: {
        position: "fixed",
        right: "2em",
        bottom: "2em",
        zIndex: 1000,
    },
    fixedMesa: {
        position: "fixed",
        right: "2em",
        bottom: "2em",
        zIndex: 2000,
    },
    fixedMesaFechar: {
        position: "fixed",
        right: "2em",
        bottom: "7em",
        zIndex: 2000,
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    rootAlert: {
        width: "100%",
        "& > * + *": {
            marginTop: theme.spacing(2),
        },
    },
    backdrop: {
        // zIndex: theme.zIndex.drawer + 999999,
        color: "#fff",
    },
    pos: {
        marginBottom: 12,
    },
    heading: {
        width: "100%",
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    rootList: {
        width: "100%!important",
        backgroundColor: theme.palette.background.paper,
    },
    inline: {
        display: "inline",
        width: "100%",
    },
    appBar: {
        position: "fixed",
    },
    appContainer: {
        paddingTop: "6em",
        backgroundColor: "#f4f4f4",
        // height: "100%",
        // minHeight: "-webkit-fill-available",
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    list: {
        width: 250,
    },
    fullList: {
        width: "auto",
    },
}))

// const libraries = ["places"]

const GooglePlacesAutocomplete = ({ setEnderecoSelecionado }) => {
    const {
        ready,
        value,
        setValue,
        suggestions: { status, data },
        clearSuggestions,
    } = usePlacesAutocomplete({
        // requestOptions: //TODO: Adicionar bias para localização https://developers.google.com/maps/documentation/javascript/reference/places-service?hl=pt-br#LocationBias
    })

    const handleSearch = e => {
        try {
            if (!e.target) return

            setValue(e.target.value)
        } catch (err) {
            console.error(err)
        }
    }

    const handleSelect = async end => {
        setValue(end, false)
        clearSuggestions()

        const response = await getGeocode({ address: end })
        const endereco = response[0]

        setEnderecoSelecionado(prev => ({
            ...prev,
            logradouro: endereco.address_components.find(addressComponent =>
                addressComponent.types.includes("route")
            )?.long_name,
            numero: endereco.address_components.find(addressComponent =>
                addressComponent.types.includes("street_number")
            )?.long_name,
            bairro: endereco.address_components.find(addressComponent =>
                addressComponent.types.includes("sublocality_level_1")
            )?.long_name,
            localidade: endereco.address_components.find(addressComponent =>
                addressComponent.types.includes("administrative_area_level_2")
            )?.long_name,
            uf: endereco.address_components.find(addressComponent =>
                addressComponent.types.includes("administrative_area_level_1")
            )?.short_name,
            cep: endereco.address_components.find(addressComponent =>
                addressComponent.types.includes("postal_code")
            )?.short_name,
            latitude: endereco.geometry.location.lat(),
            longitude: endereco.geometry.location.lng(),
        }))
    }

    return (
        <div>
            <TextField
                value={value}
                onChange={handleSearch}
                disabled={!ready}
                id="places-input"
                placeholder="Digite o endereço"
                variant="outlined"
                fullWidth
            />
            <Paper style={{ position: "absolute", zIndex: 10000 }}>
                <MenuList>
                    {data.map(({ place_id, description }) => (
                        <MenuItem
                            key={place_id}
                            value={description}
                            button
                            divider
                            onClick={e => handleSelect(description)}
                        >
                            {description}
                        </MenuItem>
                    ))}
                </MenuList>
            </Paper>
        </div>
    )
}

const CardEndereco = props => {
    const classes = useStyles()

    const { enqueueSnackbar } = useSnackbar()

    const configuracoes = useAppStore(s => s.configuracoes)

    const usarGoogleMapsAPI = configuracoes.user?.parametros?.calculoEntrega > 0

    const isLoaded = !!window.google?.maps

    const [enderecoSelecionado, setEnderecoSelecionado] = useState({
        ...props.endereco,
        bairroEspecifico: configuracoes.user.parametros.tipoEntregaBairro === 1,
    })

    const temCoordenada =
        (Number(configuracoes.user.parametros.estabelecimento.latitude) &&
            Number(configuracoes.user.parametros.estabelecimento.longitude)) ||
        (enderecoSelecionado.latitude && enderecoSelecionado.longitude)

    const mapCenter = enderecoSelecionado.latitude
        ? { lat: enderecoSelecionado.latitude, lng: enderecoSelecionado.longitude }
        : temCoordenada
        ? {
              lat: Number(configuracoes.user.parametros.estabelecimento.latitude),
              lng: Number(configuracoes.user.parametros.estabelecimento.longitude),
          }
        : { lat: -12.720151, lng: -50.43879 }

    const handleClick = () => {
        props.handleSelecionarEndereco(props.endereco, props.index)
    }

    const handleSalvar = async () => {
        const enderecoEditado = {
            id: props.endereco.id,
            appNome: configuracoes?.user?.parametros?.appNome,
            idCliente: props.idCliente,
            uf: props.endereco.uf,
            cidade: document.getElementById("endereco-cidade").value,
            bairro: document.getElementById("endereco-bairro").value,
            logradouro: document.getElementById("endereco-logradouro").value,
            numero: document.getElementById("endereco-numero").value,
            complemento: document.getElementById("endereco-complemento").value,
            referencia: document.getElementById("endereco-referencia").value,
            cep: document.getElementById("endereco-cep").value,
            versao: props.endereco.versao,
            token: "a~I?;;+_@!AL^",
        }

        const enderecoAtualizado = await AtualizarEnderecoCliente(
            props.autorizacao,
            enderecoEditado
        )

        props.endereco.id = enderecoAtualizado.id
        props.endereco.cidade = enderecoAtualizado.cidade
        props.endereco.bairro = enderecoAtualizado.bairro
        props.endereco.logradouro = enderecoAtualizado.logradouro
        props.endereco.numero = enderecoAtualizado.numero
        props.endereco.complemento = enderecoAtualizado.complemento
        props.endereco.referencia = enderecoAtualizado.referencia
        props.endereco.cep = enderecoAtualizado.cep

        setEnderecoSelecionado(prev => ({ ...prev, ...enderecoAtualizado }))

        setAbrirEdicao(false)
    }

    const handleContinuar = () => {
        setAbrirMapa(false)
        setAbrirEdicao(true)

        document.getElementById("endereco-cidade").value = enderecoSelecionado.cidade
        document.getElementById("endereco-bairro").value = enderecoSelecionado.bairro
        document.getElementById("endereco-logradouro").value = enderecoSelecionado.logradouro
        document.getElementById("endereco-numero").value = enderecoSelecionado.numero
        document.getElementById("endereco-complemento").value = enderecoSelecionado.complemento
        document.getElementById("endereco-referencia").value = enderecoSelecionado.referencia
        document.getElementById("endereco-cep").value = enderecoSelecionado.cep
    }

    const [abrirEdicao, setAbrirEdicao] = useState(false)
    const [abrirMapa, setAbrirMapa] = useState(false)
    const [abrirExcluir, setAbrirExcluir] = useState(false)
    const [excluindo, setExcluindo] = useState(false)

    const handleExcluir = async () => {
        try {
            setExcluindo(true)

            const resposta = await ExcluirEndereco(props.autorizacao, props.endereco.id)

            if (resposta?.retornoErro) {
                enqueueSnackbar(resposta.mensagem, { variant: "error" })
                return
            }

            setAbrirExcluir(false)
            props.onEnderecoExcluido(props.endereco.id)
            enqueueSnackbar("Endereço excluído com sucesso.", { variant: "success" })
        } catch (error) {
            RegistrarLogErro(error, "handleExcluir")
            enqueueSnackbar("Procure os desenvolvedores! Erro: " + error.message, {
                variant: "error",
            })
        } finally {
            setExcluindo(false)
        }
    }

    return (
        <Col xs={12} md={6} lg={4} key={props.index} style={{ marginBottom: "0.5em" }}>
            <Card className={classes.root} style={{ height: "100%" }}>
                <CardActionArea
                    onClick={handleClick}
                    style={{
                        flexFlow: "column-reverse",
                        alignItems: "normal",
                    }}
                >
                    <Row
                        style={{
                            margin: 0,
                            textAlign: "",
                            width: "100%",
                            padding: "1em",
                            alignItems: "center",
                        }}
                    >
                        <Col
                            xs={2}
                            md={2}
                            lg={2}
                            style={{
                                padding: 0,
                                textAlign: "center",
                                fontSize: "2em",
                            }}
                        >
                            <LocationOnIcon />
                        </Col>
                        <Col xs={10} md={10} lg={10}>
                            <Typography variant="body2" color="textSecondary" component="p">
                                {props.endereco.bairro} - {props.endereco.cidade}
                            </Typography>
                            <Typography gutterBottom component="h2">
                                {props.endereco.logradouro} - {props.endereco.numero}
                            </Typography>
                        </Col>
                    </Row>
                    <Tooltip title="Excluir endereço" placement="left">
                        <IconButton
                            size="small"
                            style={{
                                position: "absolute",
                                right: "0.25rem",
                                top: "0.25rem",
                                color: "#dc3545",
                            }}
                            onClick={e => {
                                e.stopPropagation()
                                setAbrirExcluir(true)
                            }}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                    <IconButton
                        size="small"
                        style={{ position: "absolute", right: "2rem", top: "0.25rem" }}
                        onClick={e => {
                            e.stopPropagation()
                            setAbrirEdicao(true)
                        }}
                    >
                        <EditIcon />
                    </IconButton>
                    {Number(props.endereco.latitude) && Number(props.endereco.longitude) ? (
                        <Tooltip title="Ver endereço no Google Maps" placement="left">
                            <IconButton
                                size="small"
                                style={{
                                    position: "absolute",
                                    right: "3.75rem",
                                    top: "0.25rem",
                                }}
                                onClick={e => {
                                    e.stopPropagation()
                                    window.open(
                                        `https://www.google.com/maps?q=${encodeURIComponent(
                                            `${props.endereco.latitude},${props.endereco.longitude}`
                                        )}`,
                                        "_blank",
                                        "noopener,noreferrer"
                                    )
                                }}
                            >
                                <MapIcon />
                            </IconButton>
                        </Tooltip>
                    ) : null}
                </CardActionArea>
            </Card>
            <Dialog
                open={abrirEdicao}
                onClose={() => setAbrirEdicao(false)}
                fullWidth
                maxWidth={"md"}
            >
                <DialogTitle>
                    <IconButton className="setaVoltarModal" onClick={() => setAbrirEdicao(false)}>
                        <ArrowForwardIosIcon />
                    </IconButton>
                    Editar Endereço
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                id="endereco-cidade"
                                variant="outlined"
                                label="Cidade"
                                defaultValue={enderecoSelecionado.cidade}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                id="endereco-bairro"
                                variant="outlined"
                                label="Bairro"
                                defaultValue={enderecoSelecionado.bairro}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                id="endereco-logradouro"
                                variant="outlined"
                                label="Rua"
                                defaultValue={enderecoSelecionado.logradouro}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                id="endereco-numero"
                                variant="outlined"
                                label="Número"
                                defaultValue={enderecoSelecionado.numero}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                id="endereco-complemento"
                                variant="outlined"
                                label="Complemento"
                                defaultValue={enderecoSelecionado.complemento}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                id="endereco-referencia"
                                variant="outlined"
                                label="Referência"
                                defaultValue={enderecoSelecionado.referencia}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                id="endereco-cep"
                                variant="outlined"
                                label="CEP"
                                defaultValue={enderecoSelecionado.cep}
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    {usarGoogleMapsAPI ? (
                        <Button
                            style={{ backgroundColor: "#28a745", color: "white" }}
                            onClick={() => setAbrirMapa(true)}
                        >
                            Usar mapa
                        </Button>
                    ) : null}
                    <Button
                        style={{ backgroundColor: "#28a745", color: "white" }}
                        onClick={handleSalvar}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
            {usarGoogleMapsAPI && isLoaded ? (
                <Dialog
                    open={abrirMapa}
                    onClose={() => setAbrirMapa(false)}
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle>
                        <IconButton className="setaVoltarModal" onClick={() => setAbrirMapa(false)}>
                            <ArrowForwardIosIcon />
                        </IconButton>
                        Editar Endereço
                    </DialogTitle>
                    <DialogContent>
                        <div>
                            <div id="places-autocomplete-container">
                                <GooglePlacesAutocomplete
                                    setEnderecoSelecionado={setEnderecoSelecionado}
                                />
                            </div>
                            <GoogleMap
                                id="google-map"
                                mapContainerStyle={{
                                    width: "100%",
                                    height: "320px",
                                    margin: "1rem auto",
                                }}
                                center={mapCenter}
                                zoom={temCoordenada ? 16 : 4}
                            >
                                <Marker position={mapCenter} />
                                {enderecoSelecionado.latitude ? (
                                    <Marker
                                        position={{
                                            lat: enderecoSelecionado.latitude,
                                            lng: enderecoSelecionado.longitude,
                                        }}
                                    />
                                ) : null}
                            </GoogleMap>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            style={{ backgroundColor: "#28a745", color: "white" }}
                            onClick={handleContinuar}
                        >
                            Continuar
                        </Button>
                    </DialogActions>
                </Dialog>
            ) : null}
            <Dialog
                open={abrirExcluir}
                onClose={() => (!excluindo ? setAbrirExcluir(false) : null)}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>Excluir endereço</DialogTitle>
                <DialogContent>
                    <Typography>
                        Tem certeza que deseja excluir o endereço{" "}
                        <b>
                            {props.endereco.logradouro} - {props.endereco.numero}
                        </b>
                        , {props.endereco.bairro} - {props.endereco.cidade}? Esta ação não pode ser
                        desfeita.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button disabled={excluindo} onClick={() => setAbrirExcluir(false)}>
                        Cancelar
                    </Button>
                    <Button
                        disabled={excluindo}
                        style={{ backgroundColor: "#dc3545", color: "white" }}
                        onClick={handleExcluir}
                    >
                        {excluindo ? "Excluindo..." : "Excluir"}
                    </Button>
                </DialogActions>
            </Dialog>
        </Col>
    )
}

export default function Index() {
    const autorizacao = localStorage.getItem("chaveSistema")
    const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    )
    const classes = useStyles()
    // const theme = useTheme()
    // const history = useHistory()

    const {
        carrinho,
        listaRepeticao,
        // ativoMinimoEntregaGratis,
        // informacoesParaBuscarCardapio,
        setCarrinho,
        listaEnderecos,
        loadingEnderecos,

        // setLoadingEstabelecimentos,
        estabelecimentosDisponiveis,
        // setInformacoesParaBuscarCardapio,
        setOpenCadastroEndereco,
        // openCadastroEndereco,
        openListaEnderecos,
        enderecoRetiradaNoLocal,
        handleSelecionarEstabelecimento,
        setListaEnderecos,
        setOpenListaEnderecos,
        // isDelivery,
        // valorDescontoManual,
        setOpenFinalizacaoPedido,
        handleToggleParteInicial,
        setOpenListaClientes,
        // calcularValorTotalPedido,

        // setOpenEstabelecimentoDisponiveis,
        // setListaEstabelecimentosDisponiveis,
        handleSelecionarEndereco,
    } = useContext(RegistradorContext)

    const { enqueueSnackbar } = useSnackbar()

    const configuracoes = useAppStore(s => s.configuracoes)

    // Entrega por Km/Raio/Area (calculoEntrega > 0) exige coordenadas. Endereco salvo sem
    // lat/long geraria Geocoding no backend -> nao exibe, forcando recadastro via mapa (Places),
    // que e mais barato (mesmo criterio do site de pedidos). Coage lat/long: podem vir number,
    // string, "" ou null. Filtro so na exibicao: nao altera listaEnderecos nem o envio do pedido.
    const exigeCoordenada =
        configuracoes.user?.parametros?.entregaExigeCoordenadas ??
        configuracoes.user?.parametros?.calculoEntrega > 0
    const enderecosVisiveis = exigeCoordenada
        ? listaEnderecos.filter(e => Number(e.latitude) && Number(e.longitude))
        : listaEnderecos

    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const [acessoEnderecoGuardado, setAcessoEnderecoGuardado] = useState()

    const handleEnderecoExcluido = idEndereco => {
        setListaEnderecos(listaEnderecos.filter(endereco => endereco.id !== idEndereco))
    }

    const handleCloseEndereco = () => {
        try {
            setOpenListaEnderecos(false)
            setListaEnderecos([])
        } catch (error) {
            RegistrarLogErro(error, "handleCloseEndereco")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    const handleRetiradaNoLocal = async () => {
        try {
            const cart = Object.assign({}, carrinho)
            cart.status = 99
            cart.tipoPedido = 1
            cart.end = enderecoRetiradaNoLocal()
            cart.appNome = configuracoes?.user?.parametros?.appNome
            cart.end.appNome = configuracoes?.user?.parametros?.appNome

            const idEstabelecimentoAtivo = configuracoes?.user?.parametros?.estabelecimento?.id

            const response = await AcessoPorEnderecoEstabelecimentosid(
                autorizacao,
                idEstabelecimentoAtivo,
                cart.end
            )
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return false
            }
            setCarrinho(cart)

            const estabelecimentoParaRetirada = response.estabelecimentos.find(
                e => e.id === idEstabelecimentoAtivo
            )

            if (estabelecimentoParaRetirada) {
                handleSelecionarEstabelecimento(estabelecimentoParaRetirada, cart)
            }

            handleCloseEndereco()

            setOpenListaClientes(false)
            setOpenFinalizacaoPedido(true)
        } catch (error) {
            RegistrarLogErro(error, "handleRetiradaNoLocal")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    async function getAcessoPorEndereco(endereco) {
        try {
            const expirationTime = Date.now() + 300000
            localStorage.setItem("expiration-acesso-endereco", expirationTime)

            const response = await AcessoPorEnderecoEstabelecimentosid(
                autorizacao,
                configuracoes?.user?.parametros?.estabelecimento?.id,
                endereco
            )
            setAcessoEnderecoGuardado(response)

            return response
        } catch (error) {
            console.error(error)
            RegistrarLogErro(error, "getAcessoPorEndereco")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    const handleClienteNaLoja = async () => {
        try {
            const cart = Object.assign({}, carrinho)
            cart.status = 99
            cart.tipoPedido = 2 //mesa
            cart.end = enderecoRetiradaNoLocal()

            cart.appNome = configuracoes.user?.parametros?.appNome
            cart.end.appNome = configuracoes.user?.parametros?.appNome

            let response = null

            const isAcessoPorEnderecoExpirado =
                !acessoEnderecoGuardado ||
                !localStorage.getItem("expiration-acesso-endereco") ||
                Date.now() > localStorage.getItem("expiration-acesso-endereco")
            if (isAcessoPorEnderecoExpirado) response = await getAcessoPorEndereco(cart.end)
            else response = acessoEnderecoGuardado

            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return false
            }

            const idEstabelecimentoAtivo = +configuracoes.user?.parametros?.estabelecimento?.id

            const estabelecimentoParaMesa = response.estabelecimentos.find(
                e => e.id === idEstabelecimentoAtivo
            )

            setCarrinho(cart)

            if (estabelecimentoParaMesa) {
                handleSelecionarEstabelecimento(estabelecimentoParaMesa, cart)
            }

            handleCloseEndereco()
            setOpenFinalizacaoPedido(true)
        } catch (error) {
            RegistrarLogErro(error, "handleClienteNaLoja")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    const handleEditarPedido = async () => {
        const params = new URLSearchParams(window.location.search)
        const idPedido = params.get("idPedido")

        try {
            const response = await ObterPedido(idPedido)

            if (response) {
                switch (response?.tipoPedido) {
                    case 1:
                        handleRetiradaNoLocal()
                        break
                    case 2:
                        handleClienteNaLoja()
                        break
                    default:
                        handleSelecionarEndereco(response?.end)
                }
            } else {
            }
        } catch (error) {
            RegistrarLogErro(error, "buscarTodosPedidos")
            alertStart("Erro ao buscar todos os pedidos!", "error")
            return false
        }
    }

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        const numeroMesa = params.get("mesa")
        const idPedido = params.get("idPedido")

        if (numeroMesa && estabelecimentosDisponiveis) {
            handleClienteNaLoja()
        }
        if (idPedido && estabelecimentosDisponiveis) {
            handleEditarPedido()
        }
    }, [estabelecimentosDisponiveis])

    return openListaEnderecos ? (
        <Dialog
            fullScreen
            open={openListaEnderecos}
            onClose={handleCloseEndereco}
            TransitionComponent={Transition}
        >
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleCloseEndereco}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        {carrinho?.cliente?.id ? (
                            <>
                                {!loadingEnderecos ? "(" + enderecosVisiveis.length + ")" : null}{" "}
                                Endereços {mobile ? "" : "Encontrados"}
                            </>
                        ) : (
                            <>Opções de Entrega</>
                        )}
                    </Typography>
                    {carrinho?.cliente?.id ? (
                        <Button
                            onClick={() => {
                                setOpenCadastroEndereco(true)
                            }}
                            style={{
                                backgroundColor: "#28a745",
                                color: "white",
                            }}
                        >
                            <Add />
                            Cadastrar {mobile ? "" : "Endereço"}
                        </Button>
                    ) : null}
                </Toolbar>
            </AppBar>

            <Container className={classes.appContainer}>
                <Row>
                    {loadingEnderecos ? (
                        <>
                            <Col xs={12} md={12} lg={12} style={{ marginBottom: "0.5em" }}>
                                <Skeleton
                                    variant="rect"
                                    width={"100%"}
                                    height={48}
                                    style={{ marginBottom: "1em" }}
                                />
                            </Col>
                            <Col xs={12} md={6} lg={6} style={{ marginBottom: "0.5em" }}>
                                <Skeleton variant="rect" width={"100%"} height={77} />
                            </Col>
                            <Col xs={12} md={6} lg={6} style={{ marginBottom: "0.5em" }}>
                                <Skeleton variant="rect" width={"100%"} height={77} />
                            </Col>
                        </>
                    ) : (
                        <>
                            <Col xs={12} md={12} lg={12} style={{ marginBottom: "0.5em" }}>
                                <AlertFixo
                                    severity="warning"
                                    style={{ width: "100%", marginBottom: "1em" }}
                                >
                                    {carrinho?.cliente?.id ? (
                                        <>
                                            Você buscou endereços do usuário{" "}
                                            <b>{carrinho.cliente?.nome}</b>.
                                        </>
                                    ) : (
                                        <>
                                            Cliente <b>anônimo</b> não é possivel cadastrar
                                            endereço.
                                        </>
                                    )}
                                </AlertFixo>
                            </Col>
                            <Col xs={12} md={6} lg={6} style={{ marginBottom: "0.5em" }}>
                                <Card className={classes.root} style={{ height: "100%" }}>
                                    <CardActionArea
                                        onClick={handleRetiradaNoLocal}
                                        style={{ flexFlow: "column-reverse", alignItems: "normal" }}
                                    >
                                        <Row
                                            style={{
                                                margin: 0,
                                                textAlign: "",
                                                width: "100%",
                                                padding: "1em",
                                                alignItems: "center",
                                            }}
                                        >
                                            <Col
                                                xs={2}
                                                md={2}
                                                lg={2}
                                                style={{
                                                    padding: 0,
                                                    textAlign: "center",
                                                    fontSize: "2em",
                                                }}
                                            >
                                                <TransferWithinAStationIcon></TransferWithinAStationIcon>
                                            </Col>
                                            <Col xs={10} md={10} lg={10}>
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    component="p"
                                                >
                                                    Pedido Para
                                                </Typography>
                                                <Typography gutterBottom component="h2">
                                                    Retirar No Local
                                                </Typography>
                                            </Col>
                                        </Row>
                                    </CardActionArea>
                                </Card>
                            </Col>
                            <Col xs={12} md={6} lg={6} style={{ marginBottom: "0.5em" }}>
                                <Card className={classes.root} style={{ height: "100%" }}>
                                    <CardActionArea
                                        onClick={handleClienteNaLoja}
                                        style={{ flexFlow: "column-reverse", alignItems: "normal" }}
                                    >
                                        <Row
                                            style={{
                                                margin: 0,
                                                textAlign: "",
                                                width: "100%",
                                                padding: "1em",
                                                alignItems: "center",
                                            }}
                                        >
                                            <Col
                                                xs={2}
                                                md={2}
                                                lg={2}
                                                style={{
                                                    padding: 0,
                                                    textAlign: "center",
                                                    fontSize: "2em",
                                                }}
                                            >
                                                <AirlineSeatReclineNormalIcon></AirlineSeatReclineNormalIcon>
                                            </Col>
                                            <Col xs={10} md={10} lg={10}>
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    component="p"
                                                >
                                                    Pedido Para
                                                </Typography>
                                                <Typography gutterBottom component="h2">
                                                    Cliente Na Mesa
                                                </Typography>
                                            </Col>
                                        </Row>
                                    </CardActionArea>
                                </Card>
                            </Col>
                        </>
                    )}

                    {loadingEnderecos ? (
                        <>
                            {listaRepeticao.map(chave => (
                                <Col
                                    xs={12}
                                    md={6}
                                    lg={4}
                                    key={chave}
                                    style={{ marginBottom: "0.5em" }}
                                >
                                    <Skeleton variant="rect" width={"100%"} height={77} />
                                </Col>
                            ))}
                        </>
                    ) : (
                        <>
                            {enderecosVisiveis.length ? (
                                enderecosVisiveis.map((endereco, index) => (
                                    <CardEndereco
                                        key={endereco.id ?? index}
                                        endereco={endereco}
                                        index={index}
                                        handleSelecionarEndereco={handleSelecionarEndereco}
                                        idCliente={carrinho?.cliente?.id}
                                        autorizacao={autorizacao}
                                        onEnderecoExcluido={handleEnderecoExcluido}
                                    />
                                ))
                            ) : carrinho?.cliente?.id ? (
                                <Col
                                    xs={12}
                                    md={12}
                                    lg={12}
                                    style={{ textAlign: "center", marginBottom: "0.5em" }}
                                >
                                    <Typography>Nenhum endereço foi encontrado.</Typography>
                                </Col>
                            ) : null}
                        </>
                    )}
                </Row>
            </Container>
        </Dialog>
    ) : (
        <React.Fragment></React.Fragment>
    )
}
